import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { globalAdminAuthGuard } from 'src/app/guards/global-admin-auth.guard';
import { adminGuard } from './guards/admin.guard';
import { smsAuthGuard } from './guards/sms-auth.guard';
import { ClientService } from './services/client.service';

/* Component Imports */
import { NoDataBoxComponent } from './modules/shared/no-data-box/no-data-box.component';
import { DataService } from './services/data.service';


export const routes: Routes = [
  { path: 'redirect/:client', loadComponent: () => import('./modules/redirect/redirect.component').then(m => m.RedirectComponent) },
  { path: '', loadComponent: () => import('./modules/login/login/login.component').then(m => m.LoginComponent), pathMatch: 'full' },
  { path: 'home', loadComponent: () => import('./modules/home/home-wrapper/home-wrapper.component').then(m => m.HomeWrapperComponent), canActivate: [smsAuthGuard] },
  { path: 'sms', loadChildren: () => import('./modules/sms/sms.routes'), canActivateChild: [smsAuthGuard] },
  { path: 'admin', loadChildren: () => import('./modules/admin/admin.routes'), canActivateChild: [adminGuard] },
  { path: 'globalAdmin', loadChildren: () => import('./modules/global-admin/global-admin.routes'), canActivateChild: [globalAdminAuthGuard] },
  {
    path: 'accessDenied',
    component: NoDataBoxComponent,
    resolve: {
      data: () => {
        const clientService = inject(ClientService);
        const ds = inject(DataService);
        const homepageRoute = clientService.getRoute(false, true) ?? '/home';
        const backRoute = ds.getSubTeamStackBackRoute();

        return {
          img: 'assets/access-denied.svg',
          title: 'Access restricted',
          message: `It looks like you don't currently have permission to view this content.
          If you believe this is an error, please contact system administrator.`,
          class: 'fullPageNoDataFound',
          actions: [{ name: backRoute ? 'Go Back' : 'Go to Homepage', type: 'route', route: backRoute ?? homepageRoute }],
        };
      },
    },
  },
  {
    path: 'pageNotFound',
    component: NoDataBoxComponent,
    resolve: {
      data: () => ({
        img: 'assets/no-data-found.svg',
        title: 'Sorry, page not found',
        message: 'We couldn\'t find the page you were looking for.',
        class: 'fullPageNoDataFound'
      })
    }
  },
  { path: '**', redirectTo: 'pageNotFound' }
];